import axios from "axios";
import { getBackendUrl } from "../config";

const api = axios.create({
	baseURL: getBackendUrl(),
	headers: { "X-Whitelabel-Host": window.location.hostname },
	withCredentials: true,
});

export const openApi = axios.create({
	baseURL: getBackendUrl(),
	headers: { "X-Whitelabel-Host": window.location.hostname }
});

export function configurePortalBackend(scope) {
  if (scope === "reseller") window.__whitelabelBackendUrl = `${window.location.origin}/backend`;
  else delete window.__whitelabelBackendUrl;
  api.defaults.baseURL = getBackendUrl();
  openApi.defaults.baseURL = getBackendUrl();
}

export default api;
